// Demo data for CourseCraft.ai portfolio demonstration
// Using actual CS10 course data: Spring 2024 → Fall 2025

export const demoData = {
  // Input course information (what user would enter)
  inputCourse: {
    department: "CS10",
    semester: "Spring",
    year: "2024",
    fullName: "The Beauty and Joy of Computing",
    instructor: "Teaching Professor Dan Garcia"
  },

  // Generated course information
  generatedCourse: {
    department: "CS10",
    semester: "Fall",
    year: "2025",
    fullName: "The Beauty and Joy of Computing",
    instructor: "Teaching Professor Dan Garcia"
  },

  sharingKey: "1al0NYfHtmimou_PTGbK1Vns0DZfZW2Hh",

  // Schedule comparison data
  scheduleComparison: {
    oldSemester: "Spring 2024",
    newSemester: "Fall 2025",
    changes: [
      "Adjusted all dates from Spring 2024 to Fall 2025",
      "Accounted for different holiday schedule (Labor Day, Veterans Day, Thanksgiving)",
      "Updated lecture recordings and resource links",
      "Maintained consistent weekly structure"
    ]
  },

  // Sample calendar events for the new semester
  sampleEvents: [
    {
      week: 1,
      date: "Wed 8/27",
      lecture: "Welcome + Abstraction",
      lab: "Welcome to Snap!",
      discussion: "Welcome to CS10!",
      assignment: "Presemester Survey Released"
    },
    {
      week: 2,
      date: "Wed 9/03",
      lecture: "Functions",
      lab: "Build Your Own Blocks",
      discussion: "Numeral Rep + Control Structures",
      assignment: ""
    },
    {
      week: 3,
      date: "Mon 9/08",
      lecture: "Abstraction II",
      lab: "Conditionals, Reporters, & Testing",
      discussion: "Domain/Range, Scoping, Iteration, Lists",
      assignment: "Proj 1: Worldle Released"
    }
  ],

  // Export format options
  exportFormats: [
    {
      name: "Google Calendar",
      icon: "📅",
      description: "Export all 170+ events directly to your Google Calendar",
      count: "170+ events"
    },
    {
      name: "ICS File",
      icon: "📄",
      description: "Download .ics file compatible with Outlook, Apple Calendar, and more",
      count: "170+ events"
    },
    {
      name: "HTML Table",
      icon: "🌐",
      description: "Embed formatted schedule table on your course website",
      format: "Responsive HTML + CSS"
    },
    {
      name: "Sharing Key",
      icon: "🔑",
      description: "Generate unique key for course staff collaboration",
      key: "1al0NYfHtmimou_PTGbK1Vns0DZfZW2Hh"
    }
  ],

  // Key features demonstrated
  features: [
    {
      title: "Smart Date Adjustment",
      description: "Automatically shifts Spring 2024 dates to Fall 2025, accounting for different semester lengths and holiday schedules",
      icon: "📆",
      example: "Mon 1/22 → Mon 9/01"
    },
    {
      title: "Holiday Detection",
      description: "Identifies holidays like Labor Day, Veterans Day, and Thanksgiving to adjust the schedule accordingly",
      icon: "🏖️",
      detected: ["Labor Day (9/1)", "Veterans Day (11/11)", "Thanksgiving Week (11/24-28)"]
    },
    {
      title: "Consistent Structure",
      description: "Maintains the same weekly rhythm: Lectures MWF, Labs M/W, Discussions Thu, Quizzes/Exams Fri",
      icon: "🔄",
      structure: "16 weeks + RRR week + Finals week"
    },
    {
      title: "Comprehensive Events",
      description: "Generates events for lectures, labs, discussions, assignments, projects, quests, midterms, and postterms",
      icon: "📋",
      types: ["28 Lectures", "21 Labs", "14 Discussions", "15+ Assignments", "5 Projects", "3 Quests", "3 Midterms", "3 Postterms"]
    }
  ],

  // Real course statistics
  stats: {
    totalWeeks: 17,
    lectures: 28,
    labs: 21,
    discussions: 14,
    assignments: 15,
    projects: 4,
    quests: 3,
    midterms: 3,
    postterms: 3,
    totalEvents: 170
  },

  // Testimonial
  testimonial: {
    quote: "CourseCraft.ai transformed what used to take me 4-6 hours into a 10-minute task. I can now focus on what really matters: supporting my students.",
    author: "CS10 Head Teaching Assistant",
    semester: "UC Berkeley, Spring 2024"
  },

  // Course details
  courseDetails: {
    lectures: {
      days: "Monday, Wednesday, Friday",
      time: "1-2PM",
      location: "Dwinelle Hall, Room 145"
    },
    labs: {
      days: "Monday, Wednesday",
      time: "3-5PM or 8-10PM",
      location: "Barker Hall, Room 101 or Soda Hall, Room 438"
    },
    discussions: {
      days: "Thursday",
      time: "4-5PM or 5-6PM",
      location: "Soda Hall, Room 438 or Stanley Hall, Room 106"
    }
  }
};

export default demoData;
